export const createProactiveAgentName = (
  baseAgent: string,
  promptName: string,
  existingNames: readonly string[]
): string => {
  // The backend stores an agent's full name, base name included, in a 100-character field
  const availableLength = 100 - baseAgent.length - 1;
  if (availableLength < 8)
    throw new Error(
      'The base agent name is too long to add a prompt name to it.'
    );

  const normalizedName = promptName
    .normalize('NFKD')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
  const suffix =
    normalizedName || crypto.randomUUID().replaceAll('-', '').slice(0, 8);
  const taken = new Set(existingNames);
  let name = `${baseAgent}-${suffix.slice(0, availableLength)}`;
  for (let version = 2; taken.has(name); version++) {
    const number = String(version);
    name = `${baseAgent}-${suffix.slice(0, availableLength - number.length)}${number}`;
  }
  return name;
};
